import { render, staticRenderFns } from "./motivosrechazo.vue?vue&type=template&id=26bd2dd6"
import script from "./motivosrechazo.vue?vue&type=script&lang=js"
export * from "./motivosrechazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports